module.exports = __webpack_public_path__ + "cof_white-orange_hex.svg?73ffe8906e1d417ce5f351796b07dc28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cof_white-orange_hex.svg
// module id = 379
// module chunks = 0